import axiosInstance from '@/services/axiosInstance';

const registerFcmToken = (token: string): Promise<unknown> =>
  axiosInstance.post('/api/v1/push/fcm-token', { token }).then((r) => r.data);

const pushApi = {
  registerFcmToken,
};

export { pushApi };
